import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Areas } from './shared/areas/areas-list';

@Component({
  selector: 'tf-settings-page-areas',
  imports: [Areas, TranslateModule],
  templateUrl: './settings-areas.component.html',
  styleUrl: './settings-areas.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AreasSettings {}
